<template>
  <mdb-container fluid>
    <material-card
      title="Pflegebericht"
      card-icon="clipboard"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modal=!modal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
      </template>
      <template v-slot:content>
        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
        <mdb-accordion
          table
          v-if="reports.length > 0"
        >
          <mdb-accordion-pane
            class="d-flex mb-2"
            type="table"
            v-for="(report, index) in reports"
            :key="index"
            title=""
            :isOpen="openPaneNum==index"
            @pane-clicked="handlePaneOpened(index)"
          >
            <mdb-chip
              color="primary lighten-4 float-left mb-0"
              text="primary"
              slot="title"
              class="px-2 mr-1"
            >
              {{ report.Datum | dateFormat }}
            </mdb-chip>
             <span
              slot="title"
              :class="report.Wichtig ? 'red-text' : ''"
              class="h5 float-left mt-1 ml-1"
              >
              {{ report.Herkunft }}
             </span>
             <mdb-badge
                class="mt-1 ml-3 float-right"
                :color="schichtColor(report.Schicht)"
                pill
                slot="title"
              >
                {{ schichtValue(report.Schicht) }}
              </mdb-badge>
            <div class="p-2 mb-3 mx-3 mb-4">
              <mdb-tbl
                striped
                hover
              >
                <mdb-tbl-body>
                  <tr>
                    <td><strong>Änderung von:</strong></td>
                    <td>{{ report.AenderungVon }}</td>
                  </tr>
                  <tr>
                    <td><strong>Beschreibung:</strong></td>
                    <td><span v-html="report.Text"></span></td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>
            </div>
          </mdb-accordion-pane>
        </mdb-accordion>
        <list-group-item
          v-else
          :title="'Keine Einträge gefunden'"
        />
      </template>
    </material-card>
    <add-patient-report-modal
      :modal-state="modal"
      @close="modal = false"
      @save="saveModal"
    />
  </mdb-container>
</template>

<script>
import { mapActions } from 'vuex'
import {
  mdbContainer,
  mdbBtn,
  mdbIcon,
  mdbBadge,
  mdbAccordion,
  mdbAccordionPane,
  mdbChip,
  mdbTbl,
  mdbTblBody,
  mdbSpinner
} from 'mdbvue';
const AddPatientReportModal = () => import('@/components/modals/AddPatientReportModal')
const MaterialCard = () => import('@/components/card/MaterialCard')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
import utils from '@/mixins/Utils'
// import moment from 'moment'

export default {
  name: 'Pflegebericht',
  mixins: [utils()],
  components: {
    mdbContainer,
    mdbBtn,
    mdbIcon,
    AddPatientReportModal,
    ListGroupItem,
    mdbBadge,
    mdbAccordion,
    mdbAccordionPane,
    mdbChip,
    MaterialCard,
    mdbTbl,
    mdbTblBody,
    mdbSpinner
  },

  data () {
    return {
      modal: false,
      openPaneNum: 0,
      reports: [],
      loading: false,
    }
  },

  created() {
    this.loadReports()
  },

  methods: {
    ...mapActions('app', ['setSchichtOption']),

    handlePaneOpened (num) {
      if (this.openPaneNum == num) {
        return (this.openPaneNum = null)
      }
      this.openPaneNum = num;
    },

    loadReports () {
      this.loading = true
      const ID = this.$route.params.id
      this.$http.get(`/Dashboard/${ID}`)
        .then(res => {
          if(res.data.data) {
            this.reports = res.data.data[0].Pflegeberichte
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveModal () {
      this.modal = false
      this.loadReports()
    }
  }
}
</script>
<style>
 @media (max-width: 575.98px) {
  .h5, h5 {
      font-size: 0.85rem !important;
  }
 }
</style>
